<template class="home-page">
  <div class="mhome-page-content">
    <!--顶部轮播图-->
    <BannerSwitch :banners="banners"/>

    <!--案例推荐展示-->
    <div class="panel-main bg-gray">
      <div class="panel-content show-image">
        <div class="show-imageDetail">
            <div class="product-slot"
                 v-for="(item, index) in showImgData"
                 :key="index">
              <router-link class="anchor"
                           v-if="item.link"
                           :to="{name: item.link}">
                <div class="cnt_wrap">
                  <img :src="item.cover"
                       alt=""/>
                  <div class="cover-box">
                    <span class="product-icon" :style="{'background-image': 'url('+item.icon+')'}"></span>
                    <h2>{{item.title}}</h2>
                  </div>
                </div>
              </router-link>
              <template v-else>
                <div class="cnt_wrap">
                  <img :src="item.cover"
                       alt=""/>
                  <div class="cover-box">
                    <span class="product-icon" :style="{'background-image': 'url('+item.icon+')'}"></span>
                    <h2>{{item.title}}</h2>
                  </div>
                </div>
              </template>
            </div>
        </div>
      </div>
    </div>

    <!--经典案例-->
    <div class="panel-main bg-gray classic-case">
      <div class="panel-content classic-case-content">
        <h3 class="title-bg title-black">经典案例</h3>
        <ul class="sub-slogan">
          <li>行业案例多</li>
          <li>市场占有率高</li>
          <li>业务覆盖面广</li>
        </ul>
      </div>
    </div>
    <swiper :items="classCases"></swiper>

    <!--业务分布-->
    <div class="panel-main departments">
      <div class="panel-content">
        <h3 class="title-bg title-black">业务分布</h3>
        <ul class="sub-slogan">
          <li>20个省业务范围覆盖 <em class="i-spread spread-cv"></em></li>
          <li>10家分支机构服务全国 <em class="i-spread spread-fs"></em></li>
          <li>3个研发中心提升技术 <em class="i-spread spread-yf"></em></li>
        </ul>
        <Map/>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderBar from '../components/HeaderBar'
  import BannerSwitch from '../components/BannerSwitch'
  import Swiper from '../components/swiper.vue';
  import Map from '../components/Map'
  import FooterBar from '../components/FooterBar'
  import fetch from '../server/index'

  export default {
    data () {
      return {
        banners: [],
        showImgData: [
          {
            cover: require('../../static/images/mobile/home/h-bio.jpg'),
            icon: require('../../static/images/mobile/home/h-i-bio.png'),
            title: '生物识别身份认证',
            abstract: '以全渠道多模态生物认证平台为核心，构建生物认证基础能力，面向各种业务场景赋能。',
            link: 'mSolution'
          },
          {
            cover: require('../../static/images/mobile/home/h-train.jpg'),
            icon: require('../../static/images/mobile/home/h-i-train.png'),
            title: '职业培训云平台',
            abstract: '运用移动互联网、流媒体、云服务、生物认证等技术，构建集培训、考试、认证、就业资讯等为一体的专业教育平台。',
            link: 'mSolution'
          },
          {
            cover: require('../../static/images/mobile/home/h-gov.jpg'),
            icon: require('../../static/images/mobile/home/h-i-gov.png'),
            title: '智慧化公共服务平台',
            abstract: '以自然语言处理、深度学习及知识图谱为核心技术，构建以自然语言为第一交互界面的新型“智能+”公共服务平台。',
            link: 'mSolution'
          },
          {
            cover: require('../../static/images/mobile/home/i-hospital.jpg'),
            icon: require('../../static/images/mobile/home/h-i-hosp.png'),
            title: '智慧医保',
            abstract: '结合医保行业权威专家团队，应用人工智能、区块链、大数据分析等技术，构建新医保数据驱动的行业解决方案。',
            link: 'mSolution'
          }
        ],
        classCases: [{
          title: '生物识别身份认证',
          background: require('../../static/images/mobile/home/i-c-bio.png'),
          link: {name: 'mCase', params: {type: 'bio'}}
        }, {
          title: '职业培训云平台',
          background: require('../../static/images/mobile/home/i-c-train.png'),
          link: {name: 'mCase', params: {type: 'oedu'}}
        }, {
          title: '智慧化公共服务平台',
          background: require('../../static/images/mobile/home/i-c-gov.png'),
          link: {name: 'mCase', params: {type: 'ssoc'}}
        }, {
          title: '智慧医保',
          background: require('../../static/images/mobile/home/i-c-hop.png'),
          link: {name: 'mCase', params: {type: 'hins'}}
        }]
      }
    },
    methods: {
      getBanners () {
        fetch('/api/advert/list').then(res => {
          this.banners = res;
        }, err => {
          console.log(err);
        }).catch(e => {
        });
      }
    },
    components: {
      HeaderBar,
      BannerSwitch,
      Swiper,
      Map,
      FooterBar
    },
    created () {
      this.getBanners()
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .mhome-page-content {
    $theme-color: #00ccff;

    /*banner轮播图*/
    .el-carousel,
    .el-carousel .el-carousel__container{
      height: 5.52rem;
      .banner{
        height: 100%;
      }
    }
    .el-carousel{
      .el-carousel__indicators{
        bottom: .35rem;
      }
    }

    /*推荐案例展示*/
    .show-image {
      @include c_wrap();
      .show-imageDetail {
        display: flex;
        flex-wrap: wrap;
        padding-top: .20rem;
        margin-left: -.16rem;
        .product-slot {
          width: 50%;
          height: 2.33rem;
          margin-bottom: .16rem;
          .cnt_wrap{
            margin-bottom: .16rem;
            margin-left: .16rem;
            border-radius: 4px;
            overflow: hidden;
            position: relative;
            z-index: 1;
          }
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
          .cover-box {
            width: 100%;
            height: 100%;
            font-size: 20px;
            font-weight: 800;
            color: #fff;
            position: absolute;
            left: 0;
            top: 0;
            background-repeat: no-repeat;
            /*background-image: linear-gradient(top, transparent 0, rgba(0, 0, 0, .8) 100%);*/
            h2 {
              font-size: .32rem;
              color: #fff;
              font-weight: lighter;
              padding-left: .22rem;
              padding-right: .22rem;
            }
            .product-icon {
              display: block;
              width: .46rem;
              height: .46rem;
              margin-top: 1.12rem;
              margin-left: .22rem;
              margin-bottom: .08rem;
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center center;
            }
          }
        }
      }
    }

    /*经典案例*/
    .classic-case {
      @include c_wrap();
      padding-top: .30rem;
      .classic-case-content {
        height: 100%;
      }
    }
    .swiper-ctner{
      margin-top: .60rem;
    }

    /*业务部门*/
    .departments {
      @include c_wrap();
      margin-top: .40rem;
      .sub-slogan{
        width: 55%;
        li{
          margin-right: 0;
        }
      }
      .i-spread{
        display: inline-block;
        width: .22rem;
        height: .26rem;
        float: right;
        background-repeat: no-repeat;
        -webkit-background-size: contain;
        background-size: contain;
        position: relative;
        top: .08rem;
        &.spread-cv{
          height: .22rem;
          background-color: #b0e3fe;
        }
        &.spread-fs{
          background-image: url('../assets/images/district/d-comp.png');
        }
        &.spread-yf{
          background-image: url('../assets/images/district/d-yf.png');
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/mobile/Home.vue